<template><div><h1>VUX V2.5.2 released</h1>
<h2><a href="/en/components/checklist.html">Checklist</a></h2>
<ul><li>[fix] emit event `input` before `on-change`</li>
<li>[feature] add attribute `inlineDesc` to `options`</li>
</ul>
<h2><a href="/en/components/inline-x-number.html">InlineXNumber</a></h2>
<ul><li>[feature] now inline-x-number is available</li>
</ul>
<h2><a href="/en/components/panel.html">Panel</a></h2>
<ul><li>[feature] Add type(4,5) and info meta(source,date,other)</li>
</ul>
<h2><a href="/en/components/popup-header.html">PopupHeader</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] Add prop:popup-style #1656</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[feature] Add prop:popup-style #1656</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] Add prop:popup-style #1656</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.2 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.2-115.vue?d3d5619a